import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import SetInvoiceDiscountTypeFormConfig from "./form";
import { InvoiceDiscountTypeDataType } from "@/formTypes/InvoiceDiscountTypeDataType";
import { useAppSelector } from "@/store/hooks";
import { useEffect, useRef } from "react";

type SetInvoiceDiscountTypeFormProps = {
  onDiscountTypeChanged: (data: InvoiceDiscountTypeDataType) => void,
  defaultData: InvoiceDiscountTypeDataType,
  innerForm?: boolean
}

const SetInvoiceDiscountTypeForm = (props: SetInvoiceDiscountTypeFormProps) => {
  const { onDiscountTypeChanged, innerForm = false, defaultData } = props;
  const formRef = useRef<DynamicFormRef>(null);
  const documentDiscountType = useAppSelector((state) => state.eDocument.documentDiscountType);

  useEffect(() => {
    setTimeout(() => {
      formRef.current?.setFormValue("discountType", documentDiscountType, "select")
    });

  }, [documentDiscountType])

  const onSubmit = (formData: InvoiceDiscountTypeDataType) => {
    if (onDiscountTypeChanged) {
      onDiscountTypeChanged(formData)
    }
  }

  return (
    <>
      <DynamicForm<InvoiceDiscountTypeDataType>
        ref={formRef}
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={SetInvoiceDiscountTypeFormConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default SetInvoiceDiscountTypeForm;